import { createContext } from "react";

export const PlayerYearsContext = createContext()
export const AnimationContext = createContext();
export const GamesLoadingContext = createContext();